// Stesso interruttore di Listino.tsx e QrAgenzie.tsx (button role="switch" + pallino animato), con
// l'area di tocco allargata a 44px attorno al disegno: serve sulle righe da telefono.
export function Interruttore({
  acceso, onClick, title, ariaLabel,
}: {
  acceso: boolean;
  onClick: () => void;
  title?: string;
  ariaLabel?: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={acceso}
      aria-label={ariaLabel}
      onClick={onClick}
      title={title}
      className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/50 after:absolute after:-inset-2.5 after:content-[''] ${
        acceso ? "bg-primary" : "bg-input"
      }`}
    >
      <span
        className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-lg transition-transform ${
          acceso ? "translate-x-5" : "translate-x-0"
        }`}
      />
    </button>
  );
}
